import { Col, Container, Row } from 'reactstrap';
import './App.css';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import AppRouter from './routing.component';
import header1 from './resources/header-1.png';

function App() {
  return (
    <div className="App">
      <Container fluid>
        <Row>
          <Col>
            <Row>
              <Header/>
            </Row>
            <Row>
              <div id="primary" className="content-area primary">
                <main id="main" className="site-main">
                  <img id="header-img" width="1024" height="585" src={header1} alt="" />
                  <article className="post page type-page status-publish has-post-thumbnail" id="post" itemScope>
                    <AppRouter/>
                  </article>
                </main>
              </div>
            </Row>
            <Row>
              <Footer/>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
